import { FC, useState, MouseEvent } from 'react'
import { Divider, IconButton, MenuItem, Typography } from '@mui/material'
import { EllipsisVerticalIcon, EyeIcon, PencilIcon, Square2StackIcon, TrashIcon } from '@heroicons/react/24/outline'
import { TemplateOptionsMenuContainer, StyledMenu } from './templateOptionsMenu.styles'

interface TemplateOptionsMenuProps {
  onView: () => void
  onEdit: () => void
  onDuplicate: () => void
  onDelete: () => void
  canEdit?: boolean
  canDelete?: boolean
}

const TemplateOptionsMenu: FC<TemplateOptionsMenuProps> = ({
  onView,
  onEdit,
  onDuplicate,
  onDelete,
  canEdit = true,
  canDelete = true
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleAction = (action: () => void) => {
    handleClose()
    action()
  }

  return (
    <TemplateOptionsMenuContainer>
      <IconButton
        className="menu-icon-button"
        aria-label="template options"
        aria-controls={open ? 'template-options-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <EllipsisVerticalIcon width={20} height={20} stroke="#E9E0E4" />
      </IconButton>
      <StyledMenu
        id="template-options-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <MenuItem key="view" onClick={() => handleAction(onView)}>
          <EyeIcon width={16} height={16} stroke="#D0C3CC" />
          <Typography>View</Typography>
        </MenuItem>
        {canEdit && (
          <MenuItem key="edit" onClick={() => handleAction(onEdit)}>
            <PencilIcon width={16} height={16} stroke="#D0C3CC" />
            <Typography>Edit</Typography>
          </MenuItem>
        )}
        <MenuItem key="duplicate" onClick={() => handleAction(onDuplicate)}>
          <Square2StackIcon width={16} height={16} stroke="#D0C3CC" />
          <Typography>Duplicate</Typography>
        </MenuItem>
        {canDelete && <Divider key="delete-divider" sx={{ margin: '0 !important' }} />}
        {canDelete && (
          <MenuItem key="delete" className="destructive" onClick={() => handleAction(onDelete)}>
            <TrashIcon width={16} height={16} stroke="#E74C3C" />
            <Typography>Delete</Typography>
          </MenuItem>
        )}
      </StyledMenu>
    </TemplateOptionsMenuContainer>
  )
}

export default TemplateOptionsMenu
